module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid border-bottom-light"
  }, [_c('div', {
    staticClass: "col-sm-12 fs-largest darker py-3"
  }, [_c('router-link', {
    staticClass: "pointer",
    attrs: {
      "to": "/reservation",
      "tag": "span"
    }
  }, [_c('i', {
    staticClass: "ico ico-arrow-left fs-larger"
  }), _vm._v("\n                " + _vm._s(_vm.product.name) + "\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4e9ef494", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9ef494"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Availability/Navigator.vue
// module id = 2772
// module chunks = 0